import { useLockBodyScroll } from "../../hooks/useLockBodyScroll";
import { useEscapeKey } from "../../hooks/useEscapeKey";
import { useThemeContext } from "../../theme/ThemeContext";
import { CHANGELOG } from "../../utils/changelog";
import { Button } from "../shared";
import { overlayBackdrop } from "../../theme/styles";

export function ChangelogModal({ onClose }) {
  const { SA, GLASS } = useThemeContext();
  useLockBodyScroll();
  useEscapeKey(onClose);
  const typeStyle = {
    new:      { bg: "#e8f5e8", border: "#4a7a4a", color: "#1a5c1a", label: "NEW" },
    improved: { bg: "#eef1fb", border: "#1a3a9e", color: "#1a3a9e", label: "IMPROVED" },
    fix:      { bg: "#fff9e6", border: "#b8920a", color: "#7a5f00", label: "FIX" },
  };

  return (
    <div style={{ ...overlayBackdrop, zIndex:3000, display:"flex", alignItems:"center", justifyContent:"center" }} onClick={onClose}>
      <div style={{ ...GLASS.modal, width:"min(480px,92vw)", maxHeight:"80vh",
        display:"flex", flexDirection:"column", overflow:"hidden" }}
        onClick={e => e.stopPropagation()}>

        {/* Header */}
        <div style={{ padding:"18px 20px 14px", borderBottom:`1px solid ${SA.borderGray}`,
          display:"flex", alignItems:"center", justifyContent:"space-between" }}>
          <div>
            <div style={{ fontSize:13, fontWeight:700, letterSpacing:"0.06em", color:SA.white }}>What's New</div>
            <div style={{ fontSize:10, color:SA.silver, letterSpacing:"0.1em", textTransform:"uppercase", marginTop:2 }}>
              LAX Connection Log
            </div>
          </div>
          <Button variant="icon" onClick={onClose}
            style={{ background: SA.medGray, color: SA.silver, width: 28, height: 28, fontSize: 16 }}>×</Button>
        </div>

        {/* Scrollable changelog */}
        <div style={{ overflowY:"auto", padding:"16px 20px", display:"flex", flexDirection:"column", gap:20 }}>
          {CHANGELOG.map((release, ri) => (
            <div key={release.version}>
              {/* Version header */}
              <div style={{ display:"flex", alignItems:"baseline", gap:10, marginBottom:10 }}>
                <span style={{ fontFamily:"'HelveticaNeueStd','Barlow','Helvetica Neue',Arial,sans-serif", fontSize:15, fontWeight:700,
                  color: ri === 0 ? SA.accent : SA.lightSilver, letterSpacing:"0.04em" }}>
                  v{release.version}
                </span>
                {ri === 0 && (
                  <span style={{ fontSize:8, fontWeight:700, letterSpacing:"0.14em", textTransform:"uppercase",
                    background:SA.accent, color:"#fff", borderRadius:3, padding:"2px 7px" }}>CURRENT</span>
                )}
                <span style={{ fontSize:10, color:SA.silver, marginLeft:"auto", letterSpacing:"0.06em" }}>
                  {release.date}
                </span>
              </div>

              {/* Change items */}
              <div style={{ display:"flex", flexDirection:"column", gap:7 }}>
                {release.changes.map((item, ci) => {
                  const ts = typeStyle[item.type] || typeStyle.fix;
                  return (
                    <div key={ci} style={{ display:"flex", alignItems:"flex-start", gap:9 }}>
                      <span style={{ flexShrink:0, fontSize:7, fontWeight:700, letterSpacing:"0.14em",
                        background:ts.bg, border:`1px solid ${ts.border}`, color:ts.color,
                        borderRadius:3, padding:"2px 6px", marginTop:1, minWidth:62, textAlign:"center" }}>
                        {ts.label}
                      </span>
                      <span style={{ fontSize:12, color:SA.lightSilver, lineHeight:1.5 }}>{item.text}</span>
                    </div>
                  );
                })}
              </div>

              {/* Divider (not after last) */}
              {ri < CHANGELOG.length - 1 && (
                <div style={{ marginTop:18, borderBottom:`1px solid ${SA.borderGray}` }} />
              )}
            </div>
          ))}
        </div>

      </div>
    </div>
  );
}
